module.exports = __webpack_public_path__ + "assets/img/text6.50a9b03b.png";